import { render, staticRenderFns } from "./NotificationsList.vue?vue&type=template&id=b594ba72&scoped=true&"
import script from "./NotificationsList.vue?vue&type=script&lang=ts&"
export * from "./NotificationsList.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsList.vue?vue&type=style&index=0&id=b594ba72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b594ba72",
  null
  
)

export default component.exports